<div class="container-fluid">
    <div class="row">
        <h4 id="upper">
            Evaluation du PDC
        </h4>
        <!-- Main Content -->
        <div class="col-md-12 p-0 main-content">


            <!-- Filtres principaux -->
            <div class="card filter-card">
                <div class="card-header">
                    Filtres de sélection
                </div>

                <div class="card-body">
                    <div class="row g-3 align-items-center justify-content-end">

                        <!-- Période PDC -->
                        <div class="col-md-auto">
                            <div class="d-flex align-items-center gap-2">
                                <label class="fw-bold mb-0">Période PDC</label>
                                <select name="selectedPdc" class="form-select" [(ngModel)]="selectedPdc"
                                    style="width: 220px;">
                                    <option [ngValue]="undefined" disabled selected>
                                        Choisir...
                                    </option>
                                    <option *ngFor="let item of pdcData" [ngValue]="item">
                                        {{ item?.annee_debut }} - {{ item?.annee_fin }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <!-- Nombre d'années -->
                        <div class="col-md-auto">
                            <div class="d-flex align-items-center gap-2">
                                <label style="white-space:nowrap;" class="fw-bold mb-0">Nombre d'années</label>
                                <input [(ngModel)]="annee" class="form-control" name="annee" type="number" />
                            </div>
                        </div>

                        <!-- Boutons -->
                        <div class="col-md-auto">
                            <div class="d-flex gap-2">
                                <button (click)="getStatistique()" type="button" class="btn btn-primary btn-sm">
                                    Rechercher
                                </button>
                                <div class="dropdown" ngbDropdown>
                                    <button type="button" ngbDropdownToggle
                                        class="btn btn-secondary btn-sm dropdown-toggle">
                                        Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>
                                    </button>

                                    <div class="dropdown-menu" ngbDropdownMenu>
                                        <a class="dropdown-item" href="javascript:void(0);"
                                            (click)="exportToDocument('pdf')">
                                            PDF
                                        </a>
                                        <a class="dropdown-item" href="javascript:void(0);"
                                            (click)="exportToDocument('excel')">
                                            Excel
                                        </a>
                                    </div>
                                </div>



                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Tableau des activités par année -->
            <div class="card">

                <div class="card-body p-0">
                    <div class="table-container">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Année</th>
                                    <th class="text-end">Tep Prévu (FCFA)</th>
                                    <th class="text-end">Tep Réalisé (FCFA)</th>
                                    <th class="text-center">Poids PDC</th>
                                    <th class="text-end">Écart</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of  paginatedProjets">
                                    <td>
                                        <span class="badge-year">{{item.annee}}</span>
                                    </td>
                                    <td class="text-end montant">{{item.tep_prevu}}</td>
                                    <td class="text-end montant">{{item.tep_realise}}</td>
                                    <td class="text-center">
                                        <span class="badge bg-secondary">{{item.poids}}</span>
                                    </td>

                                    <td class="text-end text-danger montant">{{item.tep_prevu - item.tep_realise || 0}}
                                    </td>
                                </tr>
                                <tr *ngIf="paginatedProjets.length === 0 && isLoading === false">
                                    <td colspan="8">
                                        <div class="row">
                                            <div class="text-center">
                                                <h5 id="graycolor">Aucune donnée trouvée</h5>
                                            </div>
                                        </div>
                                    </td>
                                </tr>


                            </tbody>


                        </table>


                    </div>
                </div>
                <div class="d-flex justify-content-end"
                    style="text-align: right; width: 100%; font-size: 1.2em; padding: 15px;">
                    <tr>
                        <td colspan="5" style="text-align: right; background-color: #f8f9fa; padding: 15px;">
                            <span class="badge bg-secondary"
                                style="font-size: 1.1em; margin: 0 5px; padding: 8px 15px;">
                                Tep globale : {{tepGlobale || 0}}
                            </span>
                            <span class="badge bg-secondary"
                                style="font-size: 1.1em; margin: 0 5px; padding: 8px 15px;">
                                Tep réalisé : {{tepRealse || 0}}
                            </span>
                        </td>
                    </tr>
                </div>

                <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets" [rows]="rowsProjets"
                    [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]">
                </p-paginator>
            </div>
        </div>
    </div>
</div>

<p-toast />
<ngx-ui-loader></ngx-ui-loader>